import { atom } from "recoil";
export const isLoggedErp = atom({
  key: "isLoggedErp", // unique ID (with respect to other atoms/selectors)
  default: false, // default value (aka initial value)
});
